// ─── CHAD V3 Logo Components ─────────────────────────────────────────────────
// Flowing beam mark: amber square, two dark columns, single bright S-curve
// with two endpoint dots. Playfair Display italic wordmark.
// ─────────────────────────────────────────────────────────────────────────────

export function ChadMark({ size = 28 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 72 72" style={{ flexShrink: 0, display: "block" }}>
      <rect x="2" y="2" width="68" height="68" rx="16" fill="#d4a04a" />
      <rect x="18" y="14" width="11" height="38" rx="4" fill="#161615" opacity=".82" />
      <rect x="43" y="14" width="11" height="38" rx="4" fill="#161615" opacity=".82" />
      <path d="M29 28 C36 28 36 42 43 42" fill="none" stroke="#fffbe6" strokeWidth="2.8" strokeLinecap="round" opacity=".88" />
      <circle cx="29" cy="28" r="3" fill="#fffbe6" opacity=".85" />
      <circle cx="43" cy="42" r="3" fill="#fffbe6" opacity=".85" />
    </svg>
  );
}

export function ChadWordmark({ size = 16, color }) {
  return (
    <span style={{
      fontFamily: "'Playfair Display', serif",
      fontStyle: "italic",
      fontWeight: 500,
      fontSize: size,
      letterSpacing: "1px",
      lineHeight: 1,
      color: color || "inherit",
    }}>
      Chad
    </span>
  );
}

export function ChadLogo({ markSize = 28, wordSize = 16, gap = 10, color }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap }}>
      <ChadMark size={markSize} />
      <ChadWordmark size={wordSize} color={color} />
    </div>
  );
}
